export const BUS_TECHNOLOGY = [
  {
    key: "BEB",
    dataLabel: "Energy",
    dataUnit: " kWh",
    dashboardUnit: "(kWh)",
    capacity: [
      { name: "busBatteryCapacity", label: "Battery Capacity", unit: "(kWh)" },
    ],
  },
  {
    key: "FC",
    dashboardUnit: "(kg H2/100 km)",
    dataLabel: "Fuel",
    dataUnit: "(kg H2)",
    capacity: [
      { name: "busBatteryCapacity", label: "Battery Capacity", unit: "(kWh)" },
      { name: "busFuelCapacity", label: "Fuel Capacity", unit: "(kg H2)" },
    ],
  },
  // {
  //   key: "DSL",
  //   dataLabel: "Fuel",
  //   dashboardUnit: "(L/100 km)",
  //   dataUnit: "(L)",
  //   capacity: [
  //     { name: "busFuelCapacity", label: "Fuel Capacity", unit: "(L)" },
  //   ],
  // },
  {
    key: "CNG",
    dataLabel: "Fuel",
    dashboardUnit: "(DLE/100 km)",
    dataUnit: " DLE",
    capacity: [
      { name: "busFuelCapacity", label: "Fuel Capacity", unit: "DLE" },
    ],
  },
];
export const CHARGER_TECHNOLOGY = [{ key: "Depot" }, { key: "On-Route" }];

export const BUS_MANUFACTURERS = [
  {
    label: "Proterra",
    key: "Proterra",
  },
  {
    label: "BYD",
    key: "BYD",
  },
  {
    label: "New Flyer",
    key: "New Flyer",
  },
  {
    label: "NovaBus",
    key: "NovaBus",
  },
];

export const CHARGER_MANUFACTURERS = [
  {
    label: "Proterra",
    key: "Proterra",
  },
  {
    label: "ABB",
    key: "ABB",
  },
  {
    label: "Siemens",
    key: "Siemens",
  },
  {
    label: "NovaBus",
    key: "NovaBus",
  },
  {
    label: "Heliox",
    key: "Heliox",
  },
  {
    label: "ChargePoint",
    key: "ChargePoint",
  },
  {
    label: "Power Electronics",
    key: "Power Electronics",
  },
];
